<div class="header">
  <div class="header-section">
    <a class="header-logo" routerLink="/">
      <ly-logo></ly-logo>
    </a>
  </div>
  <div class="header-section is-center">
    <ng-content></ng-content>
  </div>
  <div class="header-section is-end">
    <ly-theme-picker></ly-theme-picker>

    <div class="profile-info" (click)="menu.toggle($event)">
      <div class="profile-text">
        <span class="profile-name">{{
          profileDisplayName ? profileDisplayName : profileEmail
        }}</span>
      </div>

      @if (profileAvatarURL) {
        <img [src]="profileAvatarURL" alt="Profile Avatar" />
      } @else {
        <p-avatar
          [label]="
            profileDisplayName
              ? profileDisplayName.charAt(0).toUpperCase()
              : profileEmail.charAt(0).toUpperCase()
          "
          size="normal"
          shape="circle"
        ></p-avatar>
      }
    </div>

    <p-menu #menu [model]="menuItems()" [popup]="true">
      <ng-template pTemplate="item" let-item>
        <ng-container *ngIf="!item.separator">
          <a
            class="menu-item p-menuitem-link"
            [routerLink]="item.url"
            [class.profile-header]="item.styleClass === 'profile-header-item'"
          >
            <ng-container
              *ngIf="
                item.styleClass === 'profile-header-item';
                else regularItem
              "
            >
              @if (profileAvatarURL) {
                <p-avatar
                  class="profile-avatar"
                  [image]="profileAvatarURL || undefined"
                  size="normal"
                  shape="circle"
                >
                </p-avatar>
              } @else {
                <p-avatar
                  class="profile-avatar"
                  [label]="
                    profileDisplayName
                      ? profileDisplayName.charAt(0).toUpperCase()
                      : profileEmail.charAt(0).toUpperCase()
                  "
                  size="normal"
                  shape="circle"
                ></p-avatar>
              }
              <div class="menu-profile-info">
                <span class="profile-name">{{ item.label }}</span>
                <span class="profile-email">{{ profileEmail }}</span>
              </div>
            </ng-container>
            <ng-template #regularItem>
              <ly-icon [icon]="item.icon"></ly-icon>
              <span>{{ item.label }}</span>
            </ng-template>
          </a>
        </ng-container>
      </ng-template>
    </p-menu>
  </div>
</div>
